const data = [
  {
    name: "Frodo Baggins",
    img: "https://www.giantbomb.com/a/uploads/original/0/6843/493443-frodo.jpg",
    info: "A young well-to-do hobbit. When he discovers that the magic ring left to him by his eccentric Uncle Bilbo is the One Ring, he reluctantly takes on the quest to destroy it. Often referred to as the Ringbearer.",
  },
  {
    name: "Gandalf the Grey",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtuFPC1GaOX-mSBl89DjoiOSFj6-Tmlt02fg&usqp=CAU",
    info: " A wizard best known among hobbits for his fireworks and mischievous sense of humor, but actually one of the greatest powers of Middle-earth. He reveals the truth about the Ring to Frodo and acts as a guide and counselor. The leader of the Fellowship. Other names: Stormcrow, Mithrandir, the Grey Pilgrim, the White Rider, Tharkûn, Olórin, Incánus, and Gandalf the White.",
  },
  {
    name: "Samwise -Sam- Gamgee",
    img: "https://i.pinimg.com/736x/19/45/dc/1945dc5fe44bcdedef36548f5529502e.jpg",
    info: "A hobbit, Frodo's gardener at home, and his servant and friend on the quest. Sam is very fond of stories about dragons and elves. A member of the Fellowship, he stays with Frodo after it is broken.",
  },
  {
    name: "Meriadoc -Merry- Brandybuck",
    img: "https://pm1.aminoapps.com/6554/857b5592675c989c75762e1eb36d86eafde8839e_00.jpg",
    info: "A young hobbit, one of Frodo's many cousins. A member of the Fellowship. Friend of Treebeard the Ent and companion of King Théoden of Rohan.",
  },
  {
    name: "Peregrin -Pippin- Took",
    img: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/79dc962d-ed92-487d-98b3-3b80aff0a39a/d7ydpis-9919ad31-389d-40c7-bf1c-38ffdf7a1d4d.jpg/v1/fill/w_400,h_562,q_75,strp/pippin_and_his_daemon_by_lj_todd_d7ydpis-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTYyIiwicGF0aCI6IlwvZlwvNzlkYzk2MmQtZWQ5Mi00ODdkLTk4YjMtM2I4MGFmZjBhMzlhXC9kN3lkcGlzLTk5MTlhZDMxLTM4OWQtNDBjNy1iZjFjLTM4ZmZkZjdhMWQ0ZC5qcGciLCJ3aWR0aCI6Ijw9NDAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.xxiUr1cOkPKc1nWfEb9M8nZEcEgAewRLXdWlG6aGlvM",
    info: "A young hobbit, one of Frodo's many cousins. A member of the Fellowship. Later, a member of the Tower Guard of Minas Tirith.",
  },
  {
    name: "Aragorn",
    img: "https://i.pinimg.com/originals/4f/37/e4/4f37e46b043c7d99fa69f6b41d73a28b.jpg",
    info: "The heir of Isildur and the rightful king of Gondor, a mighty warrior and healer. He was raised by the elves of Rivendell and now lives in exile as leader of the Dúnedain, the Rangers of the North. The time has now come for him to reclaim the throne. He leads the Fellowship after Gandalf's fall. Other names: Strider, Elessar, Elfstone, Dúnadan.",
  },
  {
    name: "Legolas",
    img: "https://i.pinimg.com/originals/66/bb/a1/66bba1f4b1f5a0ffd1ed5c11cddc2824.jpg",
    info: "Son of Thranduil, king of the Mirkwood elves. He is a great archer with keen eyesight. A member of the Fellowship. Close friend of Gimli the dwarf and companion of Aragorn.",
  },
];

export default data;
